import { render, staticRenderFns } from "./PwaTitle.vue?vue&type=template&id=60932d4d&"
import script from "./PwaTitle.vue?vue&type=script&lang=js&"
export * from "./PwaTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports